import { DefaultEntityAdapter } from './default-entity.adapter';
import { RadioAdapter } from './interfaces/radio.adapter';

export class DefaultRadioAdapter<T>
  extends DefaultEntityAdapter<T>
  implements RadioAdapter<T>
{
  constructor(
    idField = 'id',
    labelField = 'label',
    iconField = 'icon',
    protected readonly colorField = 'color',
    protected readonly selectedBackgroundColorField = 'selectedBackgroundColor',
    protected readonly selectedTextColorField = 'selectedTextColor',
  ) {
    super(idField, labelField, iconField);
  }

  public getColor(item: T): string | undefined {
    return (item as Record<string, unknown>)[this.colorField] as
      | string
      | undefined;
  }

  public getSelectedBackgroundColor(item: T): string | undefined {
    return (item as Record<string, unknown>)[
      this.selectedBackgroundColorField
    ] as string | undefined;
  }

  public getSelectedTextColor(item: T): string | undefined {
    return (item as Record<string, unknown>)[this.selectedTextColorField] as
      | string
      | undefined;
  }
}
